import * as Cash from '../../node_modules/cash-dom/dist/cash.js';
// cash is a CJS, but converted to module by Rollup.
let cash = window.cash;
if (!cash && Cash.default) {
  cash = Cash.default;
}
window.$ = cash;
export default cash;
